import type { Locale } from "./catalogs.js";

const ar = {
  navDashboard: "لوحة المتابعة",
  navInstruments: "الشيكات والتحويلات",
  navReports: "التقارير",
  dashboardTitle: "لوحة المتابعة",
  dashboardDescription: "ملخص هادئ للتحصيل والمتأخرات ووسائل الأداء في انتظار التحصيل.",
  obligationMonth: "شهر الاستحقاق",
  periodFrom: "من",
  periodTo: "إلى",
  refresh: "تحديث",
  collection: "تحصيل الشهر",
  settledAllocations: "المخصصات المؤداة",
  netObligations: "صافي الواجبات",
  income: "الدخل المؤدى",
  gross: "الإجمالي",
  cancellations: "الإلغاءات",
  net: "الصافي",
  arrears: "الأشهر المتأخرة",
  oneMonth: "شهر واحد",
  twoMonths: "شهران",
  threePlusMonths: "3 أشهر فأكثر",
  urgent: "حالات مستعجلة (شهران فأكثر)",
  overdueRegistration: "تسجيل متأخر",
  pendingCheques: "شيكات في انتظار التحصيل",
  pendingTransfers: "تحويلات في انتظار التحصيل",
  dashboardFailed: "تعذر تحميل لوحة المتابعة.",
  instrumentsTitle: "الشيكات والتحويلات",
  instrumentsDescription: "تأكيد الأداء أو تسجيل الرفض بعد مراجعة كشف البنك.",
  pending: "في انتظار التحصيل",
  settled: "مؤدى",
  cleared: "تم تحصيله",
  verified: "تم التحقق منه",
  rejected: "مرفوض",
  settle: "تأكيد الأداء",
  reject: "رفض",
  bankStatementDate: "التاريخ المؤكد في كشف البنك",
  bankStatementReference: "مرجع كشف البنك (اختياري)",
  reason: "السبب",
  settlementReasonHelp: "السبب مطلوب عند الرفض أو عدم التطابق.",
  confirmSettlement: "تأكيد الأداء وإصدار الوصل",
  confirmRejection: "تأكيد الرفض",
  instrumentsEmpty: "لا توجد وسائل أداء.",
  instrumentsFailed: "تعذر تحميل قائمة وسائل الأداء.",
  instrumentSaved: "تم حفظ الحالة.",
  onlineOnly: "هذا الإجراء متاح عند الاتصال فقط.",
  reportsTitle: "التقارير",
  reportsDescription: "تقرير يومي أو شهري حسب تاريخ الأداء والإلغاء.",
  daily: "يومي",
  monthly: "شهري",
  reportDate: "التاريخ",
  reportMonth: "الشهر",
  generate: "عرض التقرير",
  printReport: "طباعة أو حفظ PDF",
  byMethod: "حسب طريقة الأداء",
  byOperator: "حسب المسؤول",
  activity: "تفصيل النشاط",
  settlement: "أداء",
  cancellation: "إلغاء",
  reportEmpty: "لا يوجد نشاط في الفترة المختارة.",
  reportFailed: "تعذر تحميل التقرير.",
  reportPeriod: "الفترة",
  obligationActionTitle: "إجراء على الواجب",
  obligationActionDescription: "أضف واقعة جديدة مع الحفاظ على المبلغ الأصلي.",
  discount: "تخفيض ثابت",
  waiver: "إعفاء كامل من المتبقي",
  adjustment: "تصحيح واقعي",
  adjustmentHelp: "استخدم مبلغاً موجباً للزيادة أو سالباً للتخفيض.",
  actionAmount: "المبلغ بالدرهم",
  effectiveDate: "تاريخ السريان",
  actionReason: "السبب الإلزامي",
  saveAction: "حفظ الإجراء",
  originalCharge: "المبلغ الأصلي",
  currentRemaining: "المتبقي الحالي",
  actionFailed: "تعذر حفظ الإجراء. راجع المبلغ والسبب.",
  actionSaved: "تمت إضافة الإجراء.",
  cancelPaymentTitle: "إلغاء الأداء بالكامل",
  cancelPaymentDescription: "يبقى الأداء والوصل الأصليان محفوظين وتُستعاد كل التخصيصات.",
  cancellationDate: "تاريخ الإلغاء",
  cancellationReason: "سبب الإلغاء",
  cancellationWarning: "لا يمكن التراجع عن هذا الإلغاء. أي تحصيل مصحح يجب أن يكون أداءً جديداً.",
  confirmCancellation: "تأكيد الإلغاء الكامل",
  cancellationFailed: "تعذر إلغاء الأداء.",
  cancelled: "ملغى",
  newPaymentRequired: "سجل أي تحصيل مصحح كأداء جديد.",
  receiptLanguage: "لغة الوصل",
  downloadReceipt: "تنزيل الوصل",
  guardianLink: "رابط الولي المقيد",
  createLink: "إنشاء الرابط",
  regenerateLink: "تجديد الرابط",
  revokeLink: "إلغاء الرابط",
  copyLink: "نسخ الرابط",
  linkActive: "الرابط فعّال",
  linkInactive: "لا يوجد رابط فعّال",
  whatsapp: "إرسال عبر WhatsApp",
  whatsappGenerate: "إنشاء رابط WhatsApp",
  whatsappPreparing: "جارٍ إنشاء رابط WhatsApp…",
  whatsappRetry: "إعادة المحاولة",
  whatsappCopy: "نسخ الرسالة والرابط",
  whatsappCopied: "تم نسخ الرسالة والرابط",
  whatsappPrepareFailed: "تعذر تحضير WhatsApp. تحقق من الاتصال ثم أعد المحاولة.",
  whatsappCopyFailed: "تعذر النسخ. اسمح بالوصول إلى الحافظة ثم أعد المحاولة.",
  whatsappReceiptPrefix: "وصل الأداء",
  whatsappOffline: "أعد الاتصال ثم ابدأ المشاركة من جديد.",
  receiptActionFailed: "تعذر إتمام إجراء الوصل.",
  close: "إغلاق",
  cancel: "إلغاء",
  loading: "جارٍ التحميل",
  students: "طلاب",
  amount: "المبلغ",
  method: "الطريقة",
  operator: "المسؤول",
  date: "التاريخ",
  reference: "المرجع",
  cheque: "شيك",
  transfer: "تحويل",
  cash: "نقداً",
} as const;

const fr = {
  navDashboard: "Tableau de bord",
  navInstruments: "Chèques et virements",
  navReports: "Rapports",
  dashboardTitle: "Tableau de bord",
  dashboardDescription: "Synthèse sobre des encaissements, retards et instruments en attente.",
  obligationMonth: "Mois d’obligation",
  periodFrom: "Du",
  periodTo: "Au",
  refresh: "Actualiser",
  collection: "Recouvrement du mois",
  settledAllocations: "Affectations réglées",
  netObligations: "Obligations nettes",
  income: "Encaissement réglé",
  gross: "Brut",
  cancellations: "Annulations",
  net: "Net",
  arrears: "Mois en retard",
  oneMonth: "1 mois",
  twoMonths: "2 mois",
  threePlusMonths: "3 mois et plus",
  urgent: "Cas urgents (2 mois et plus)",
  overdueRegistration: "Inscription en retard",
  pendingCheques: "Chèques en attente",
  pendingTransfers: "Virements en attente",
  dashboardFailed: "Le tableau de bord n’a pas pu être chargé.",
  instrumentsTitle: "Chèques et virements",
  instrumentsDescription: "Confirmez le règlement ou le rejet après contrôle du relevé bancaire.",
  pending: "En attente",
  settled: "Réglé",
  cleared: "Encaissé",
  verified: "Vérifié",
  rejected: "Rejeté",
  settle: "Confirmer le règlement",
  reject: "Rejeter",
  bankStatementDate: "Date confirmée sur le relevé bancaire",
  bankStatementReference: "Référence du relevé (facultative)",
  reason: "Motif",
  settlementReasonHelp: "Le motif est obligatoire en cas de rejet ou d’écart.",
  confirmSettlement: "Confirmer et émettre le reçu",
  confirmRejection: "Confirmer le rejet",
  instrumentsEmpty: "Aucun instrument enregistré.",
  instrumentsFailed: "La liste des instruments n’a pas pu être chargée.",
  instrumentSaved: "État enregistré.",
  onlineOnly: "Cette action est disponible en ligne uniquement.",
  reportsTitle: "Rapports",
  reportsDescription: "Rapport quotidien ou mensuel selon les dates de règlement et d’annulation.",
  daily: "Quotidien",
  monthly: "Mensuel",
  reportDate: "Date",
  reportMonth: "Mois",
  generate: "Afficher le rapport",
  printReport: "Imprimer ou enregistrer en PDF",
  byMethod: "Par mode",
  byOperator: "Par opérateur",
  activity: "Détail de l’activité",
  settlement: "Règlement",
  cancellation: "Annulation",
  reportEmpty: "Aucune activité pour la période choisie.",
  reportFailed: "Le rapport n’a pas pu être chargé.",
  reportPeriod: "Période",
  obligationActionTitle: "Action sur l’obligation",
  obligationActionDescription: "Ajoutez un fait sans modifier le montant initial.",
  discount: "Remise fixe",
  waiver: "Exonération du solde restant",
  adjustment: "Ajustement factuel",
  adjustmentHelp: "Utilisez un montant positif pour augmenter ou négatif pour réduire.",
  actionAmount: "Montant en MAD",
  effectiveDate: "Date d’effet",
  actionReason: "Motif obligatoire",
  saveAction: "Enregistrer l’action",
  originalCharge: "Montant initial",
  currentRemaining: "Solde actuel",
  actionFailed: "L’action n’a pas été enregistrée. Vérifiez le montant et le motif.",
  actionSaved: "Action ajoutée.",
  cancelPaymentTitle: "Annuler intégralement le paiement",
  cancelPaymentDescription:
    "Le paiement et le reçu d’origine restent conservés et toutes les affectations sont restaurées.",
  cancellationDate: "Date d’annulation",
  cancellationReason: "Motif de l’annulation",
  cancellationWarning:
    "Cette annulation est définitive. Tout encaissement corrigé doit être un nouveau paiement.",
  confirmCancellation: "Confirmer l’annulation intégrale",
  cancellationFailed: "Le paiement n’a pas pu être annulé.",
  cancelled: "Annulé",
  newPaymentRequired: "Enregistrez tout encaissement corrigé comme nouveau paiement.",
  receiptLanguage: "Langue du reçu",
  downloadReceipt: "Télécharger le reçu",
  guardianLink: "Lien restreint du responsable",
  createLink: "Créer le lien",
  regenerateLink: "Régénérer le lien",
  revokeLink: "Révoquer le lien",
  copyLink: "Copier le lien",
  linkActive: "Lien actif",
  linkInactive: "Aucun lien actif",
  whatsapp: "Envoyer via WhatsApp",
  whatsappGenerate: "Générer le lien WhatsApp",
  whatsappPreparing: "Génération du lien WhatsApp…",
  whatsappRetry: "Réessayer",
  whatsappCopy: "Copier le message et le lien",
  whatsappCopied: "Message et lien copiés",
  whatsappPrepareFailed: "WhatsApp n’a pas pu être préparé. Vérifiez la connexion puis réessayez.",
  whatsappCopyFailed: "La copie a échoué. Autorisez l’accès au presse-papiers puis réessayez.",
  whatsappReceiptPrefix: "Reçu de paiement",
  whatsappOffline: "Reconnectez-vous puis recommencez le partage.",
  receiptActionFailed: "L’action sur le reçu a échoué.",
  close: "Fermer",
  cancel: "Annuler",
  loading: "Chargement",
  students: "Élèves",
  amount: "Montant",
  method: "Mode",
  operator: "Opérateur",
  date: "Date",
  reference: "Référence",
  cheque: "Chèque",
  transfer: "Virement",
  cash: "Espèces",
} as const satisfies Record<keyof typeof ar, string>;

export type OperationsMessageKey = keyof typeof ar;

export function operationsMessages(locale: Locale): Record<OperationsMessageKey, string> {
  return locale === "ar" ? ar : fr;
}
